<template>
  <div class="health-ios-container">
    <router-link to="/" class="center-button">
      <span class="button-text">返回</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HealthIOS'
}
</script>

<style scoped>
.health-ios-container {
  width: 100%;
  min-height: 100vh;
  background-image: url('~@/assets/health_coming_底图.jpg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  padding: 0;
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-button {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 60px;
  background-image: url('~@/assets/health_coming_按钮.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.button-text {
  color: #003366;
  font-size: 18px;
  font-weight: bold;
  z-index: 1;
}
</style>
